import Container from '@components/layout/Container'
import FullScreenSection from '@components/layout/FullScreenSection'
import getFlexProperty from '@operations/utils/getFlexProperty'
import useMediaQuery, { maxWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'

const FullScreenContainer = ({ fullScreenSection, container, children }) => {
  const isMobile = useMediaQuery(maxWidthQueries.sm)
  const hasFullScreenSection = fullScreenSection && fullScreenSection.useFullScreen
  const hasContainer = container && container.useContainer
  let comp = children
  if (hasContainer)
    comp = (
      <Container
        alignItems={getFlexProperty(container.alignItems)}
        background={{
          backgroundColor: container.backgroundColor,
        }}
        color={container.textColor}
        flexDirection={getFlexProperty(container.direction)}
        justifyContent={getFlexProperty(container.justifyContent)}
        margin={isMobile ? fullScreenSection?.marginMobile : fullScreenSection?.margin}
        padding={isMobile ? container.paddingMobile : container.padding}
        wrap="wrap"
      >
        {children}
      </Container>
    )
  if (hasFullScreenSection) {
    return (
      <FullScreenSection
        align={getFlexProperty(fullScreenSection.alignItems)}
        background={{
          backgroundColor: fullScreenSection?.backgroundColor,
          backgroundImage: `url(${fullScreenSection?.backgroundImage?.formats.medium?.url})`,
          backgroundRepeat: fullScreenSection?.backgroundRepeat,
        }}
        direction={getFlexProperty(fullScreenSection.direction)}
        height={fullScreenSection?.height}
        justify={getFlexProperty(fullScreenSection.justifyContent)}
        margin={isMobile ? fullScreenSection?.marginMobile : fullScreenSection?.margin}
        marginTop={fullScreenSection?.marginMobile || fullScreenSection?.margin ? 0 : undefined}
        maxHeight={fullScreenSection?.maxHeight}
        padding={isMobile ? fullScreenSection?.paddingMobile : fullScreenSection?.padding}
        wrap="wrap"
      >
        {comp}
      </FullScreenSection>
    )
  }
  return comp
}

export default FullScreenContainer
